document.documentElement.classList.remove('no-js');
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    var menu = document.querySelector('[data-mobile-menu]');
    var open = document.body.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.hidden = !open;
  }
  var close = event.target.closest('[data-menu-close]');
  if (close) {
    document.body.classList.remove('menu-open');
    document.querySelector('[data-mobile-menu]').hidden = true;
    document.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', 'false');
  }
});
document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;
  var option = event.target.options[event.target.selectedIndex];
  var form = event.target.closest('form');
  var button = form.querySelector('[type="submit"]');
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.querySelector('span').textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
  var price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (history.replaceState) history.replaceState({}, '', location.pathname + '?variant=' + option.value);
});
document.addEventListener('click', function(event){
  var thumb = event.target.closest('[data-product-thumb]');
  if(!thumb) return;
  var main = document.querySelector('[data-product-main-image]');
  if(main){ main.src = thumb.dataset.src; main.srcset = ''; }
  document.querySelectorAll('[data-product-thumb]').forEach(function(el){ el.classList.remove('is-active'); });
  thumb.classList.add('is-active');
});
